// extracted by mini-css-extract-plugin
export default {"moviecard":"MovieCard_moviecard__P3UIP","all":"MovieCard_all__B8q9z","gradient":"MovieCard_gradient__odpvI","movieImage":"MovieCard_movieImage__qRpF2"};